const Credits = () => {
  return (
    <div>
      <h1>credits</h1>
    </div>
  );
};

export default Credits;
